module.exports = "/_next/static/images/logo_2-f5715c521cc8189bb7dd10afc76a4d39.svg";